import { defineStore } from 'pinia';

export interface IProgressState {
  currentState: string;
  states: Map<string, string>;
}

export const useProgressStore = defineStore('progress', {
  state: (): IProgressState => {
    return {
      currentState: '',
      states: new Map([
        ['Selection', 'selection'],
        ['Récapitulatif', 'recap'],
        ['Nettoyage', 'clean'],
        ['Installation', 'install'],
        ['Validation', 'validate'],
        ['Fin', 'finished'],
      ]),
    };
  },
});
